import { urlBaseApi } from '../consts';



export const list = (token,page,limit) => {
  return {
    url: `${urlBaseApi}/members/list/credit/balance?page=${page}&limit=${limit}`,
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token
    }
  };
};

export const updateStatus = (token, payload) => {
  return {
    url: `${urlBaseApi}/members/update/credit/balance`,
    method: 'PUT',
    headers: {
      Authorization: 'Bearer ' + token
    },
    data: payload
  };
};